import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVisitHistoryService {
  temrVisitHistory: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_visit_history/list/?';
  private AddRecord = webapi + 'temr_visit_history/create';
  private AddRecordForEMRHistory = webapi + 'temr_visit_history/createForEMRHistory';
  private EditRecord = webapi + 'temr_visit_history/update';
  private GetRecord = webapi + 'temr_visit_history/byid/';
  private DeleteRecord = webapi + 'temr_visit_history/delete/';
  private GetRecordByVisitId = webapi + 'temr_visit_history/byidVisitId/';
  private GetRecordServiceByTimelineId = webapi + 'temr_visit_history/byidtimelineId/';
  private GetHistorydetailsByPatientId = webapi + 'temr_visit_history/getHistorydetailsByPatientId/';
  private GetAllRecordByTimelineList = webapi + 'temr_visit_history/getAllRecordByTimelineList';
  private GetRecordByPatientId = webapi + 'temr_visit_history/by_patient_id/';
  private GetRecordByPatientIdHistory = webapi + 'temr_visit_history/by_timeline_id/';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
     // console.log(model);
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
 addRecordServiceForEmrHistory(model: any) {
     // console.log(model);
    return this.http.post(this.AddRecordForEMRHistory, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getRecordServiceByVisitId(id: any) {
    return this.http.get(this.GetRecordByVisitId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServiceByTimelineId(id: any) {
    // console.log(this.GetRecordServiceByTimelineId + id)
    return this.http.get(this.GetRecordServiceByTimelineId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getHistorydetailsByPatientId(patientId: any, startdate: any, enddate: any, page: any, size: any) {
    return this.http.get(this.GetHistorydetailsByPatientId + patientId + '/' + startdate + '/' + enddate + '/' + page + '/' + size)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getRecordByPatientId(id: any) {
        return this.http.get(this.GetRecordByPatientId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByPatientIdHistory(id: any) {
        return this.http.get(this.GetRecordByPatientIdHistory + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-visit-history/temr-visit-history.service.ts